export default "__VITE_ASSET__Dvv7zMAO__"